/**
 * DI-3-S48-FE (story §2.14 / §3.7, Christian 2026-10-23) — the ONE place the
 * bottom pills live: a fixed row at the bottom centre of the browser edge,
 * never in flow (zero layout shift). DL-02's download pill renders in it
 * (`DownloadManagerHost docked`) and the intake pill portals into it
 * (`features/intake/wizard/IntakeStatusBar.tsx`, `PILL_DOCK_ID`) — when both
 * run they sit side by side, the intake pill first, and never overlap. The
 * row itself takes no pointer events (only the pills do), and it sits under
 * the dialogs' layer: a modal covers both pills.
 */
import type { ReactElement, ReactNode } from "react";
import { Box } from "@mui/material";
import { spacing } from "@aeriosiq/ui";
import { PILL_DOCK_ID } from "../../features/intake/wizard/IntakeStatusBar.js";

export function PillDock({ children }: { children?: ReactNode }): ReactElement {
  return (
    <Box
      id={PILL_DOCK_ID}
      data-testid="bottom-pill-dock"
      sx={{
        position: "fixed",
        left: "50%",
        transform: "translateX(-50%)",
        bottom: `${String(spacing["4"])}px`,
        zIndex: (t) => t.zIndex.appBar - 1,
        display: "flex",
        alignItems: "center",
        gap: 1,
        maxWidth: `calc(100vw - ${String(spacing["8"])}px)`,
        pointerEvents: "none",
      }}
    >
      {children}
    </Box>
  );
}
